module.exports = __webpack_public_path__ + "static/media/logistic-icon.f2270de2.svg";